module.exports = __webpack_public_path__ + "static/mapLocation2-162a4be631245998d82d406dcc75ef89.png";